import { EventBus } from '../../core/events/EventBus';
import { DuelService, Duel } from '../../services/DuelService';

export class DuelInviteModal {
  private static overlayEl: HTMLElement | null = null;
  private static timeoutTimer: any = null;

  static init() {
    EventBus.on('duel:invite_received', (payload: any) => {
      this.show(payload.duel, payload.challengerName);
    });
  }

  static show(duel: Duel, challengerName: string): void {
    if (this.overlayEl) return;

    const overlay = document.createElement('div');
    overlay.className = 'ad-interstitial-overlay';
    overlay.style.zIndex = '1000000';
    overlay.style.backdropFilter = 'blur(10px)';
    
    overlay.innerHTML = `
      <div class="glass-panel" style="width:90%;max-width:380px;padding:32px;border-radius:24px;background:#1e293b;border:2px solid #e11d48;display:flex;flex-direction:column;gap:20px;position:relative;align-items:center;text-align:center;box-shadow: 0 0 40px rgba(225, 29, 72, 0.4); animation: pulse-border 2s infinite;">
        <div style="font-size:3.5rem; margin-bottom:-10px;">⚔️</div>
        <h2 style="font-size:1.6rem;font-weight:900;color:#fff;">Meydan Okuma!</h2>
        <p style="color:#cbd5e1;font-size:1.05rem;">
          <strong style="color:#f43f5e;font-size:1.2rem;">${challengerName}</strong> seni <strong>${duel.game_id}</strong> oyununda düelloya davet ediyor!
        </p>
        
        <div style="display:flex;gap:12px;width:100%;margin-top:10px;">
          <button id="reject-duel-btn" style="flex:1;padding:12px;background:transparent;border:2px solid #334155;color:#94a3b8;border-radius:12px;font-weight:700;font-size:1rem;cursor:pointer;transition:all 0.2s;">
            Reddet
          </button>
          <button id="accept-duel-btn" style="flex:1;padding:12px;background:linear-gradient(135deg,#f43f5e,#e11d48);border:none;color:#fff;border-radius:12px;font-weight:800;font-size:1.1rem;cursor:pointer;box-shadow:0 4px 15px rgba(225,29,72,0.4);transition:transform 0.2s;">
            Kabul Et!
          </button>
        </div>
        <div style="width:100%; height:4px; background:#334155; border-radius:2px; margin-top:10px; overflow:hidden;">
          <div id="duel-timeout-bar" style="height:100%; width:100%; background:#e11d48; transition: width 15s linear;"></div>
        </div>
      </div>
      <style>
        @keyframes pulse-border {
          0% { box-shadow: 0 0 0 0 rgba(225,29,72,0.4); }
          70% { box-shadow: 0 0 0 20px rgba(225,29,72,0); }
          100% { box-shadow: 0 0 0 0 rgba(225,29,72,0); }
        }
      </style>
    `;

    document.body.appendChild(overlay);
    this.overlayEl = overlay;

    // Trigger animation
    setTimeout(() => {
      const bar = document.getElementById('duel-timeout-bar');
      if (bar) bar.style.width = '0%';
    }, 50);

    // Auto reject after 15 seconds
    this.timeoutTimer = setTimeout(() => {
      DuelService.rejectInvite(duel);
      this.close();
    }, 15000);

    overlay.querySelector('#accept-duel-btn')?.addEventListener('click', () => {
      clearTimeout(this.timeoutTimer);
      DuelService.acceptInvite(duel);
      this.close();
    });

    overlay.querySelector('#reject-duel-btn')?.addEventListener('click', () => {
      clearTimeout(this.timeoutTimer);
      DuelService.rejectInvite(duel);
      this.close();
    });
  }

  static close(): void {
    if (this.overlayEl) {
      this.overlayEl.remove();
      this.overlayEl = null;
    }
    if (this.timeoutTimer) {
      clearTimeout(this.timeoutTimer);
      this.timeoutTimer = null;
    }
  }
}
